import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "@/app/i18n/client";
import { BusRequest } from "@/types/busrequest";
import { formatDate } from "date-fns";
import { formatFullDate } from "@/constants/constants";
interface Props {
  request: BusRequest;
}
function RequestItem(t0) {
  const $ = _c(8);
  const {
    title,
    value
  } = t0;
  if (!value || "") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== title) {
    t1 = <div className="font-bold">{title}</div>;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== value) {
    t2 = <div className="text-pretty">{value}</div>;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex items-start justify-between gap-2 pt-1">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export default function RequestModalContent(t0) {
  const $ = _c(70);
  const {
    request
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("HOME.MODALS.CREATED_AT.TEXT");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== request.created_at) {
    t2 = formatDate(request.created_at, formatFullDate);
    $[2] = request.created_at;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <RequestItem title={t1} value={t2} />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== request.category || $[8] !== t) {
    t4 = request.category === "emergency" || request.category === "vacancy" ? t("HOME.MODALS.LOCATION.TEXT") : t("HOME.MODALS.FROMWHERE.TEXT");
    $[7] = request.category;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== request.start.address.address || $[11] !== t4) {
    t5 = <RequestItem title={t4} value={request.start.address.address} />;
    $[10] = request.start.address.address;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== request.category || $[14] !== request.end || $[15] !== t) {
    t6 = request.category !== "vacancy" && <RequestItem title={request.category === "emergency" ? t("HOME.MODALS.PLANNEDDESTINATION.TEXT") : t("HOME.MODALS.TOWHERE.TEXT")} value={request.end.address.address} />;
    $[13] = request.category;
    $[14] = request.end;
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== request.category || $[18] !== t) {
    t7 = request.category === "emergency" ? t("HOME.MODALS.DATE.SUBMITTED") : request.category === "vacancy" ? t("HOME.MODALS.START.TEXT") : t("HOME.MODALS.OUTWARD.TEXT");
    $[17] = request.category;
    $[18] = t;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== request.start.date) {
    t8 = formatDate(new Date(request.start.date), formatFullDate);
    $[20] = request.start.date;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <RequestItem title={t7} value={t8} />;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== request.category || $[26] !== request.end || $[27] !== t) {
    t10 = request.category !== "emergency" && <RequestItem title={request.category === "vacancy" ? t("HOME.MODALS.END.TEXT") : t("HOME.MODALS.RETURN.TEXT")} value={request.end.date !== 0 ? formatDate(new Date(request.end.date), formatFullDate) : ""} />;
    $[25] = request.category;
    $[26] = request.end;
    $[27] = t;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t) {
    t11 = t("HOME.MODALS.PAX.TEXT");
    $[29] = t;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== request.participants) {
    t12 = request.participants?.toString() || "";
    $[31] = request.participants;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t11 || $[34] !== t12) {
    t13 = <RequestItem title={t11} value={t12} />;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== request.activityRadius || $[37] !== request.category || $[38] !== t) {
    t14 = request.category === "vacancy" && <RequestItem title={t("HOME.MODALS.RADIUS.TEXT")} value={request.activityRadius?.toString() || ""} />;
    $[36] = request.activityRadius;
    $[37] = request.category;
    $[38] = t;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t) {
    t15 = t("HOME.MODALS.CAPACITY.TEXT");
    $[40] = t;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== request.capacity) {
    t16 = request.capacity?.toString() || "";
    $[42] = request.capacity;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t15 || $[45] !== t16) {
    t17 = <RequestItem title={t15} value={t16} />;
    $[44] = t15;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t) {
    t18 = t("HOME.MODALS.DESCRIPTION.TEXT");
    $[47] = t;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== request.description || $[50] !== t18) {
    t19 = <RequestItem title={t18} value={request.description} />;
    $[49] = request.description;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== request.transferType || $[53] !== t) {
    t20 = request.transferType === "transfertwoway" && <div className="card-body-info-item-content"><i>{t("HOME.MODALS.TRANSFERTWOWAYBUSNOTNEEDED")}</i></div>;
    $[52] = request.transferType;
    $[53] = t;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== request.transferType || $[56] !== t) {
    t21 = request.transferType === "transfertour" && <div className="card-body-info-item-content"><i>{t("HOME.MODALS.BUSNEEDED")}</i></div>;
    $[55] = request.transferType;
    $[56] = t;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== t10 || $[59] !== t13 || $[60] !== t14 || $[61] !== t17 || $[62] !== t19 || $[63] !== t20 || $[64] !== t21 || $[65] !== t3 || $[66] !== t5 || $[67] !== t6 || $[68] !== t9) {
    t22 = <div className="card-body"><div className="flex flex-col gap-1 divide-x-0 divide-y divide-dashed divide-secondary pr-2">{t3}{t5}{t6}{t9}{t10}{t13}{t14}{t17}{t19}{t20}{t21}</div></div>;
    $[58] = t10;
    $[59] = t13;
    $[60] = t14;
    $[61] = t17;
    $[62] = t19;
    $[63] = t20;
    $[64] = t21;
    $[65] = t3;
    $[66] = t5;
    $[67] = t6;
    $[68] = t9;
    $[69] = t22;
  } else {
    t22 = $[69];
  }
  return t22;
}